import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../contexts/LanguageContext';

const Impressum = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1, { state: { scrollToTop: true } });
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 50);
  };

  return (
    <div className="min-h-screen pt-16 bg-[#1a1a1a]">
      {/* Header */}
      <section className="py-12 sm:py-20 bg-[#1a1a1a] border-b border-white/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center relative">
            <button
              onClick={handleClose}
              className="absolute top-0 right-0 p-2 text-white/60 hover:text-[#8b7355] transition-colors"
              aria-label="Close"
            >
              <X className="w-8 h-8" />
            </button>
            <p className="text-xs tracking-[0.3em] uppercase text-[#8b7355] mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              {language === 'de' ? 'RECHTLICHES' : 'LEGAL'}
            </p>
            <h1 className="text-4xl sm:text-6xl md:text-7xl text-white mb-4 font-bold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              {language === 'de' ? 'Impressum' : 'Imprint'}
            </h1>
            <div className="w-16 h-[1px] bg-white/40 mx-auto" />
          </div>
        </div>
      </section>

      {/* Impressum Content */}
      <section className="py-12 sm:py-16 bg-[#1a1a1a]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto bg-[#2a2a2a] border border-[#e67e22] rounded-lg p-8 sm:p-12">
            
            <div className="space-y-8 text-white/70">
              {/* Company Info */}
              <div>
                <h2 className="text-2xl text-[#8b7355] mb-4" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>SLÁI Events</h2>
                {language === 'de' ? (
                  <p className="leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Inhaber: Cem Koptas<br />
                    Bärensteinstraße 2<br />
                    12685 Berlin<br />
                    Deutschland
                  </p>
                ) : (
                  <p className="leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}>
                    Owner: Cem Koptas<br />
                    Bärensteinstraße 2<br />
                    12685 Berlin<br />
                    Germany
                  </p>
                )}
              </div>

              {/* Contact */}
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">{t.impressum.contact}</h2>
                <p className="leading-relaxed">
                  {language === 'de' ? 'E-Mail' : 'Email'}: <a href="mailto:info@slaievents.com" className="text-[#8b7355] hover:underline">info@slaievents.com</a><br />
                  {language === 'de' ? 'Telefon' : 'Phone'}: <a href="tel:+4901622755781" className="text-[#8b7355] hover:underline">+49 0162 2755781</a>
                </p>
              </div>

              {/* Business Registration */}
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">{t.impressum.registration}</h2>
                <p className="leading-relaxed">
                  {language === 'de' 
                    ? 'Gewerbeanmeldung nach § 14 GewO' 
                    : 'Business registration according to § 14 German Trade Regulation Act (GewO)'}
                </p>
              </div>

              {/* Responsible */}
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">{t.impressum.responsible}</h2>
                <p className="leading-relaxed">
                  {language === 'de' 
                    ? 'Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV:' 
                    : 'Responsible for content according to § 18 (2) German Media State Treaty (MStV):'}<br />
                  Cem Koptas
                </p>
              </div>

              {/* Online Dispute Resolution */}
              <div>
                <h2 className="text-2xl font-bold text-white mb-4">{t.impressum.disputeResolution}</h2>
                <p className="leading-relaxed mb-4">
                  {language === 'de'
                    ? 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:'
                    : 'The European Commission provides a platform for online dispute resolution (ODR):'}
                </p>
                <p className="mb-4">
                  <a 
                    href="https://ec.europa.eu/consumers/odr" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#8b7355] hover:underline break-all"
                  >
                    https://ec.europa.eu/consumers/odr
                  </a>
                </p>
                <p className="leading-relaxed text-white/60">
                  {language === 'de'
                    ? 'Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.'
                    : 'We are neither obliged nor willing to participate in dispute resolution proceedings before a consumer arbitration board.'}
                </p>
              </div>

              {/* Close Button */}
              <div className="flex justify-center mt-12 pt-8 border-t border-white/20">
                <Button
                  onClick={handleClose}
                  className="bg-[#3a3a3a] text-white border border-[#e67e22] hover:bg-[#4a4a4a] rounded-none uppercase tracking-[0.15em] text-xs px-8 py-3"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  <X className="w-4 h-4 mr-2" />
                  SCHLIESSEN
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;
